import $ from 'jquery';
import { showSidebarTab } from '~src/sidebarLegacy';
import { getState, unsetState } from '~src/state';
import { toggleSaveNavMenu } from '~core/navbar';
import injectExpandCanvasHtml from './injectExpandCanvasHtml';

export default function stopExpand(tabTargetId) {
  const selection = getState('expandSelection');
  if (selection) {
    window.canvas.setActiveObject(selection);
  }
  unsetState('isExpandActive');
  unsetState('expandCoordinates');
  unsetState('stopKeyboardListener');
  unsetState('expandSelection');
  if (!tabTargetId) {
    showSidebarTab('edit-images-ai');
  }
  const initialCanvasZoom = getState('initialCanvasZoom');
  $('#canvas-zoom').css('transform', `scale(${initialCanvasZoom})`);
  $('#editor-zoom-controls').show();
  $('#drawing-expand-canvas').fadeOut(() => {
    $('#expand-canvas-container').hide();
    $('#main-canvas-container').fadeIn();
    $('#canvas').removeClass('locked').show();
  });
  window.expandDrawingCanvas.clear();
  window.expandDrawingCanvas.dispose();
  window.expandDrawingCanvas = null;
  injectExpandCanvasHtml();
  toggleSaveNavMenu();

  $('.sidebar-item-grid-box-click-listener').off('click');
  $('#editor-menu-exec-ai-expand').prop('disabled', true);
  $('#editor-menu-apply-ai-expand').prop('disabled', true);
}
